import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../../../models/usuarios.service';
import { Router } from '@angular/router';

@Component({
    selector: 'users_trocar_senha',
    templateUrl: 'users_trocar_senha.component.html'
})

export class UserTrocarSenhaComponent implements OnInit {
    senha:string='';
    senha2:string='';
    mensagem:string='';
    constructor(private users:UsersService,
    private router : Router) { }

    ngOnInit() { }

   enviar(){
      if (this.senha.length<5)
         this.mensagem = 'senha muito curta' ;
      else   
      if (this.senha==this.senha2){ 
       this.users.trocarSenha(this.senha).then(rsp=>{
        this.router.navigate(['/login']);
       }).catch(e=>{
           this.mensagem = e.message;
       });
      }
      else
        this.mensagem = 'senha não confere'
   }

}